import { FinSobSidePanelSettingGroup } from 'partner360/models/finSobSidePanel/FinSobSidePanelSettingGroup'
import { FinSobSidePanelSettingStatus } from 'partner360/models/finSobSidePanel/FinSobSidePanelSettingStatus'
import { IFinSobSidePanelSetting } from 'partner360/models/finSobSidePanel/IFinSobSidePanelSetting'

export const isOfferingPlanningCompleted = (items: IFinSobSidePanelSetting[]) => {
  const requiredPlans = items.filter(
    (item) =>
      item.GroupMark === FinSobSidePanelSettingGroup.Planning &&
      !!item.IsApplicable &&
      !item.IsBlocked
  )

  return (
    requiredPlans.length > 0 &&
    requiredPlans.every((item) => item.Status === FinSobSidePanelSettingStatus.Completed)
  )
}
